import { useState } from 'react'

import { EaInformationIcon } from '@eastcoal/icon/EaInformationIcon'

import { FloorBlock } from '../../../components/FloorBlock'
import { NewsMoreLink } from '../../../components/NewsMoreLink'

import { NewsTabs } from './Tabs'

export const NewsFloor = () => {
  const [catalogueCode, setCatalogueCode] = useState<string>()

  return (
    <FloorBlock
      extra={<NewsMoreLink catalogueCode={catalogueCode} />}
      icon={<EaInformationIcon />}
      title='行业资讯'
    >
      <NewsTabs value={catalogueCode} onChange={setCatalogueCode} />
    </FloorBlock>
  )
}
